import { Component, Inject, Input } from '@angular/core';
import * as _ from "lodash";

@Component({
    selector: 'impact-analysis-header',
    template: require('./impact-analysis-header.html'),
    styles: [require('./impact-analysis-header.scss')]
})
export class ImpactAnalysisHeaderComponent {
    public processData: any;
    public icon: any;
    public isRollbackExecution: boolean


    @Input() public set items(data: any) {

        if (data) {
            this.processData = data
            this.icon = this.$statuses[data.status] && this.$statuses[data.status].Icon ? this.$statuses[data.status].Icon : ""
            this.isRollbackExecution = this.$stateParams.isRollbackExecution;
        }
    }


    constructor(@Inject('$stateParams') private $stateParams: any, @Inject('statuses') private $statuses: any) {


    }

}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/authorized/project/impact-analysis/impact-analysis-header-ang7/impact-analysis-header.ts